import { render } from "./vnc.vue?vue&type=template&id=6bae18fc"
import script from "./vnc.vue?vue&type=script&lang=js"
export * from "./vnc.vue?vue&type=script&lang=js"

import "./vnc.vue?vue&type=style&index=0&id=6bae18fc&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__